<template>
  <ChatFrame class="wrapchat" v-resize="onResizeScreen">
    <template v-slot:header>
      <template v-if="$store.getters.setting.logo">
        <img :src="publicUrl($store.getters.setting.logo)" style="max-height: 25px" />
      </template>
      <template v-else>
        {{ userid || ' ' }}
      </template>
    </template>
    <div
      id="chatbox"
      :class="{ 'pb-5': quick_replies, 'pb-3': !quick_replies }"
      style="flex-grow: 1; overflow: auto; position: relative"
    >
      <div class="pa-3 chatboxinside">
        <transition-group name="list" tag="div">
          <div v-for="(message, k) in messages" :key="k" :class="`messageitem-` + message.actor">
            <div :class="message.actor == 'answer' ? `mr-2` : 'ml-2'">
              <v-avatar size="40px" color="#efefef" style="border: 1px solid #eee">
                <v-img v-if="message.actor == 'answer'" :src="publicUrl(setting.image)" />
                <v-icon color="grey" v-else size="30px">mdi-account</v-icon>
              </v-avatar>
            </div>
            <div
              :style="{ 'align-items': message.actor == 'question' ? 'flex-end' : 'flex-start' }"
              style="display: flex; flex-direction: column; width: calc(100% - 40px)"
            >
              <message-bubble
                style="width: 100%"
                @sendMessage="sendMessage"
                :message="message"
                :background="message.actor == 'question' ? setting.clientBubbleColor : null"
                :color="message.actor == 'question' ? setting.clientTextColor : null"
              />
              <div class="grey--text" style="font-size: 10px" v-if="message.timestamp">
                {{ message.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <div style="position: relative">
      <div style="position: absolute; top: -45px; width: 100%; width: 100%">
        <transition name="list">
          <div v-if="showToBottom" class="text-center tobottom">
            <v-btn @click="scrollToBottom" icon elevation="2" small>
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
          <template v-else>
            <div
              class="text-center"
              style="
                white-space: nowrap;
                overflow-x: auto;
                overflow-y: hidden;
                padding-bottom: 15px;
              "
              :style="{ width: screenWidth ? `${screenWidth}px` : 'auto' }"
            >
              <v-chip
                small
                @click="
                  sendMessage({
                    title: item,
                    payload: item
                  })
                  quick_replies = ''
                "
                dense
                v-ripple
                color="primary"
                outlined
                class="ml-2 text-capitalize"
                style="background-color: white !important; box-shadow: 1px 3px 12px 0px #0000003d"
                v-for="(item, k) in quick_replies"
                :key="k"
              >
                {{ item }}</v-chip
              >
            </div>
          </template>
        </transition>
      </div>

      <div style="width: 100%">
        <v-card>
          <v-text-field
            @keyup.enter="
              sendMessage({
                title: input,
                payload: input
              })
            "
            hide-actions
            v-model="input"
            hide-details
            class="mb-0"
            placeholder="Type a message..."
            flat
            solo
          >
            <template v-slot:prepend v-if="setting.hasUploadImage">
              <UploadSingleFile v-model="uploadImage" @input="onUploadFile">
                <v-btn
                  icon
                  color="#455A64"
                  style="transform: rotate(45deg); padding-bottom: 12px"
                  plain
                  :ripple="false"
                >
                  <v-icon>mdi-paperclip</v-icon>
                </v-btn>
              </UploadSingleFile>
            </template>
            <template v-slot:append>
              <template v-if="['TRUEID', 'TRUEIDTEST'].includes($store.state.apiKey)">
                <v-btn
                  @click="
                    sendMessage({
                      title: input,
                      payload: input
                    })
                  "
                  color="primary"
                  dark
                  icon
                >
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </template>
              <template v-else>
                <v-btn
                  @click="
                    sendMessage({
                      title: input,
                      payload: input
                    })
                  "
                  color="primary"
                  dark
                >
                  send
                </v-btn>
              </template>
            </template>
          </v-text-field>
        </v-card>
      </div>
    </div>
  </ChatFrame>
</template>

<script>
import Chat from './Chat.js'
import ChatFrame from '@/components/ChatFrame/ChatFrame'
export default {
  mixins: [Chat],
  components: {
    ChatFrame
  }
}
</script>

<style lang="scss" scoped>
.messageitem-question {
  display: flex;
  margin-bottom: 16px;
  flex-direction: row-reverse;
}
.messageitem-answer {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
}
.wrapchat {
  display: flex;
  flex-direction: column;
  height: 100% !important;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(20px);
}
</style>
